import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import ServicePackageModal from "../../modals/ServicePackageModal/ServicePackageModal";
import "./VehicleServicesCard.css";

export default function VehicleServicesCard({ vehicle }) {
  const [show, setShow] = useState(false);

  const hasServicePackages =
    vehicle?.servicePackages &&
    vehicle?.servicePackages?.variants?.length > 0;

  return (
    <>
      <Card className="vehicle-services-card">
        {vehicle.imageSrc && (
          <Card.Img
            variant="top"
            src={vehicle.imageSrc}
            alt={vehicle.title}
            className="vehicle-services-card__image"
          />
        )}

        <Card.Body>
          <Card.Title className="vehicle-services-card__title">
            {vehicle.title}
          </Card.Title>

          <Button
            variant="link"
            className="vehicle-services-card__link lk-brand-link"
            onClick={() => setShow(true)}
            disabled={!hasServicePackages}
          >
            {hasServicePackages ? "Explore Service Package" : "Coming Soon"}
          </Button>
        </Card.Body>
      </Card>

      {hasServicePackages && (
        <ServicePackageModal
          show={show}
          onHide={() => setShow(false)}
          vehicle={vehicle}
        />
      )}
    </>
  );
}
